// ===========================================
// AccessChip (roles slice 2)
// ===========================================
// The one chip that says what a login can do in the office: an Admin shows the school's owner
// title ("Principal"; "Admin" by default), a staff member their role's name in its colour, anyone
// else nothing. Never the bare word "Admin", and never the login role of a staff member.

import { Chip } from '@mui/material';
import { useOwnerTitle } from '../../hooks/useOwnerTitle';

interface AccessChipProps {
  role: string;
  staffRole?: { name: string; color: string | null } | null;
}

export default function AccessChip({ role, staffRole }: AccessChipProps) {
  const ownerTitle = useOwnerTitle();
  if (role === 'ADMIN') {
    return <Chip label={ownerTitle} size="small" color="secondary" />;
  }
  if (staffRole) {
    const bgcolor = staffRole.color ?? '#68707B';
    return (
      <Chip
        label={staffRole.name}
        size="small"
        sx={{ bgcolor, color: (theme) => theme.palette.getContrastText(bgcolor) }}
      />
    );
  }
  return null;
}
